<template>
  <svg
    class="icon"
    aria-hidden="true"
    @click="(e) => this.$emit('click', e)"
    ref="ref"
    v-html="use"
  ></svg>
</template>

<script>
export default {
  props: {
    type: String, // iconfont项目“WPS学院”里各图标的symbol值
  },

  computed: {
    use() {
      return `<use xlink:href="#${this.type}"></use>`;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>